//--------------- IMPORTAÇÕES ---------------//
import { useContext, useEffect } from "react"; // Importação de Hooks
import { Navigate } from "react-router-dom"; // Importação do Navigate para navegação entre páginas
import { Loading } from "../"
import { checkService } from "./services";
import { PrivateRouteContext } from "./context/PrivateRouteContext";



//--------------- EXPORTAÇÃO DO COMPONENTE PRIVATE ROUTE ---------------//
export default function PrivateRoute({ children }) {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { isLoading, setIsLoading } = useContext(PrivateRouteContext); // Estado que armazena se a tela de carregamento está ocorrendo ou não
    const { authenticated, setAuthenticated } = useContext(PrivateRouteContext);




    //--------------- USE EFFECT DE INICIALIZAÇÃO ---------------//
    useEffect(() => {
        handleCheckAuth();
    }, []);



    //--------------- FUNÇÃO ASSÍNCRONA HANDLE CHECK AUTH ---------------//
    async function handleCheckAuth() {
        const response = await checkService();
        setAuthenticated(!!response);
        setIsLoading(false);
    }




    //--------------- RETORNO CONDICIONAL DO COMPONENTE PRIVATE ROUTE ---------------//
    if (isLoading) { // Se está carregando, então retorna o componente Loading
        return <Loading />;
    } else { // Se não, retorna o "children", caso o usuário esteja autenticado, se não redireciona-o para a página de Login
        return authenticated ? children : <Navigate to="/login" />;
    }
}